import { WellKnownDirectories } from "../../../../Common/WellKnownDirectories";

import { ChainableValueProducer } from "./ChainableValueProducer";
import { DirectoryEntriesProducer } from "./DirectoryEntriesProducer";
import { EmptyProducer } from "./EmptyProducer";
import { FileSystemEntriesProducer } from "./FileSystemEntriesProducer";
import { FileValueProducer } from "./FileValueProducer";
import { SingleValueProducer } from "./SingleValueProducer";
import { FixedDirectoryEntriesProducer } from "./FixedDirectoryEntriesProducer";

export class Observe {
    public static empty(): EmptyProducer {
        return new EmptyProducer();
    }

    public static value<T>(x: T): SingleValueProducer<T> {
        return new SingleValueProducer<T>(x);
    }

    public static formDirectories(repositoryRoot: string, gfvMasks: string[]): ChainableValueProducer<string[]> {
        return new DirectoryEntriesProducer(repositoryRoot, [
            ...gfvMasks.map(x => `forms/**/${x}/${WellKnownDirectories.CandySubdirectoryName}`),
            ...gfvMasks.map(x => `${WellKnownDirectories.TestFarmDir}/forms/${x}`),
            ...gfvMasks.map(x => `candy.farm/forms/${x}`),
            ...gfvMasks.map(x => `candy.rpn.farm/forms/${x}`),
            ...gfvMasks.map(x => `candy.diadoc.farm/forms/${x}`),
        ]).skipUpdatesUntilNextCompleted();
    }

    public static fixedFormDirectories(directories: string[]): ChainableValueProducer<string[]> {
        return new FixedDirectoryEntriesProducer(directories).skipUpdatesUntilNextCompleted();
    }

    public static files(pathToDir: string, ...masks: string[]): ChainableValueProducer<string> {
        return new FileSystemEntriesProducer(pathToDir, masks).skipUpdatesUntilNextCompleted();
    }

    public static file(pathToFile: string): ChainableValueProducer<string> {
        return new FileValueProducer(pathToFile).skipUpdatesUntilNextCompleted();
    }
}
